import l,{useState as B}from"react";import h from"react";var g=({content:a,children:e})=>h.createElement("div",{className:"relative group","data-id":"element-54"},e,h.createElement("div",{className:`
          absolute
          left-1/2
          -translate-x-1/2
          bottom-full
          mb-2
          px-2
          py-1
          bg-gray-800
          text-white
          text-sm
          rounded
          opacity-0
          group-hover:opacity-100
          transition-opacity
          whitespace-nowrap
        `,role:"tooltip","data-id":"element-55"},a));import{forwardRef as b,createElement as U}from"react";var w=a=>a.replace(/([a-z0-9])([A-Z])/g,"$1-$2").toLowerCase(),n=(...a)=>a.filter((e,t,o)=>!!e&&o.indexOf(e)===t).join(" ");import{forwardRef as y,createElement as k}from"react";var P={xmlns:"http://www.w3.org/2000/svg",width:24,height:24,viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"};var A=y(({color:a="currentColor",size:e=24,strokeWidth:t=2,absoluteStrokeWidth:o,className:d="",children:u,iconNode:f,...r},L)=>k("svg",{ref:L,...P,width:e,height:e,stroke:a,strokeWidth:o?Number(t)*24/Number(e):t,className:n("lucide",d),...r},[...f.map(([I,c])=>k(I,c)),...Array.isArray(u)?u:[u]]));var p=(a,e)=>{let t=b(({className:o,...d},u)=>U(A,{ref:u,iconNode:e,className:n(`lucide-${w(a)}`,o),...d}));return t.displayName=`${a}`,t};var s=p("Circle",[["circle",{cx:"12",cy:"12",r:"10",key:"1mglay"}]]);var i=p("X",[["path",{d:"M18 6 6 18",key:"1bl5f8"}],["path",{d:"m6 6 12 12",key:"d8bk6v"}]]);var v={xs:"w-6 h-6 text-xs",sm:"w-8 h-8 text-sm",md:"w-10 h-10 text-base",lg:"w-12 h-12 text-lg",xl:"w-16 h-16 text-xl"},F={circle:"rounded-full",rounded:"rounded-lg",square:"rounded-none"},O={online:"bg-white",away:"bg-gray-400",busy:"bg-gray-600",offline:"bg-gray-300"},C=({src:a,alt:e,size:t="md",shape:o="circle",status:d,name:u,tooltip:f,className:r="",hasBorder:L=!1,hasShadow:I=!1})=>{let[c,D]=B(!0),[x,M]=B(!1),R=T=>T.split(" ").map(q=>q[0]).join("").toUpperCase().slice(0,2),S=l.createElement("div",{className:`
        relative inline-flex items-center justify-center
        ${v[t]}
        ${F[o]}
        ${L?"border-2 border-gray-200":""}
        ${I?"shadow-md":""}
        ${r}
        bg-gray-100
        overflow-hidden
        transition-all
        hover:bg-gray-200
        focus:outline-none focus:ring-2 focus:ring-gray-400
      `,"data-id":"element-41"},a&&!x?l.createElement("img",{src:a,alt:e,className:`
            w-full h-full object-cover
            ${c?"opacity-0":"opacity-100"}
          `,onLoad:()=>D(!1),onError:()=>M(!0),"data-id":"element-42"}):l.createElement("span",{className:"font-medium text-gray-600","data-id":"element-43"},R(u)),d&&l.createElement("span",{className:`
            absolute bottom-0 right-0
            w-1/3 h-1/3
            ${O[d]}
            ${F.circle}
            border-2 border-gray-100
          `,role:"status","aria-label":`Status: ${d}`,"data-id":"element-44"}),c&&!x&&l.createElement("div",{className:"absolute inset-0 flex items-center justify-center bg-gray-100","data-id":"element-45"},l.createElement(s,{className:"w-1/2 h-1/2 text-gray-400 animate-spin","data-id":"element-46"})),x&&l.createElement("div",{className:"absolute inset-0 flex items-center justify-center bg-gray-100","data-id":"element-47"},l.createElement(i,{className:"w-1/2 h-1/2 text-gray-400","data-id":"element-48"})));return f?l.createElement(g,{content:f,"data-id":"element-49"},S):S};import m from"react";var H=({avatars:a,max:e,size:t="md",className:o=""})=>{let d=e?a.slice(0,e):a,u=e?Math.max(0,a.length-e):0;return m.createElement("div",{className:`flex items-center ${o}`,"data-id":"element-50"},d.map((f,r)=>m.createElement("div",{key:r,className:`
            ${r!==0?"-ml-2":""}
            relative
            hover:z-10
          `,"data-id":"element-51"},m.createElement(C,{...f,size:t,"data-id":"element-52"}))),u>0&&m.createElement("div",{className:`
            -ml-2
            relative
            hover:z-10
            inline-flex
            items-center
            justify-center
            bg-gray-200
            ${t?`${G[t]}`:""}
            rounded-full
            font-medium
            text-gray-600
          `,"data-id":"element-53"},"+",u))},G={xs:"w-6 h-6 text-xs",sm:"w-8 h-8 text-sm",md:"w-10 h-10 text-base",lg:"w-12 h-12 text-lg",xl:"w-16 h-16 text-xl"};export{C as Avatar,H as AvatarGroup};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/circle.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/x.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.441.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
